export default __webpack_public_path__ + "static/media/logo.dd2f5352.png";